
<div
  [ngClass]="{
    'fgbcl-predictor': groupType == groupTypes.Predictor,
    'fgbcl-trivia fgbcl-game-result-section-trivia-width': groupType == groupTypes.Trivia,
  }"
  class="fgbcl-game-result-section"
>
<ng-container *ngIf="groupType !== groupTypes.Predictor || !isExternal">
  <ng-container *ngIf="percentage >= 50; else betterluck">
    <h5 class="fgbcl-game-result-status-text">{{ 'fgbcl.game.result.model.heading.text' | translate }}</h5>
  </ng-container>
  <ng-template #betterluck>
    <h5 class="fgbcl-game-result-status-text-better-luck">
      {{ 'fgbcl.game.result.model.better-luck' | translate }}
    </h5>
  </ng-template>
  <ng-container *ngIf="totalCorrectAnswer == totalQuestions; else notAllCorrect">
    <div class="fgbcl-game-result-description">{{ 'fgbcl.game.result.model.heading.description.allcorrect' | translate }}</div>
  </ng-container>
  <ng-template #notAllCorrect>
    <div class="fgbcl-game-result-description">{{ 'fgbcl.game.result.model.heading.description.notallcorrect' | translate }}</div>
  </ng-template>
  <div class="fgbcl-game-result-progress-bars-section">
    <div class="fgbcl-game-result-progress-bars fgbcl-game-total-correct-answer-progress-bar">
      <fgbcl-circle-progress-bar [value]="totalCorrectAnswer" [maxValue]="totalQuestions" [strokeTheme]="'success'">
        <div class="fgbcl-game-total-correct-answer-value">{{ totalCorrectAnswer }}</div>
        <div class="fgbcl-game-total-question-text">{{ 'fgbcl.game.result.out.of.text' | translate }} {{ totalQuestions }}</div>
      </fgbcl-circle-progress-bar>
    </div>
    <ng-container *ngIf="totalPoints">
      <div class="fgbcl-game-result-progress-bars fgbcl-game-total-point-progress-bar">
        <fgbcl-circle-progress-bar [value]="totalPoints" [maxValue]="totalPoints" [strokeTheme]="'black'">
          <div class="fgbcl-game-total-point-text">{{ 'fgbcl.game.total.point.label' | translate }}</div>
          <div class="fgbcl-game-total-point-value-section">
            <div class="fgbcl-game-flash-circle-icon">
              <span class="material-icons align-middle">{{ pointIcon }}</span>
            </div>
            <div class="fgbcl-game-total-point-value">{{ totalPoints }}</div>
          </div>
        </fgbcl-circle-progress-bar>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="prize && prize.PrizeValue">
    <fgbcl-game-result-prize [prize]="prize"></fgbcl-game-result-prize>
  </ng-container>

  <ng-container *ngIf="showShareWithFriendButton && !isExternal">
    <fgbcl-social-share-modal
      shareType="scorecards"
      [urlPage]="redirectPageURL"
      [loyaltyCategoryType]="loyaltyCategoryType"
    ></fgbcl-social-share-modal>
  </ng-container>

  <button
    *ngIf="groupType == groupTypes.Trivia && !isExternal"
    (click)="closeModalButton()"
    class="fgbcl-game-back-to-game-button"
  >
    {{ 'fgbcl.game.back.button.text' | translate }}
  </button>
</ng-container>

  <!-- Custom content projection -->
  <ng-content></ng-content>
</div>
